import { useEffect } from '@wordpress/element';
import { confirmSwishPayment } from './confirm-swish-payment';

/**
 * @typedef {import('@woocommerce/type-defs/registered-payment-method-props').EventRegistrationProps} EventRegistrationProps
 * @typedef {import('@woocommerce/type-defs/registered-payment-method-props').BillingDataProps} BillingDataProps
 * @typedef {import('@woocommerce/type-defs/registered-payment-method-props').EmitResponseProps} EmitResponseProps
 * @typedef {import('react').Dispatch<string>} SourceIdDispatch
 */

/**
 * A custom hook for the Stripe processing and event observer logic.
 *
 * @param {EventRegistrationProps} eventRegistration Event registration functions.
 * @param {BillingDataProps}       billing           Various billing data items.
 * @param {EmitResponseProps}      emitResponse      Various helpers for usage with observer
 *                                                   response objects.
 *
 * @return {function(Object):Object} Returns a function for handling stripe error.
 */
export const swishPaymentCompleteHandler = (
	onCheckoutSuccess,
	setIsModalOpen,
	setQrCodeData,
	setSwishToken,
	setSwishLink,
	emitResponse
) => {

	// Once the server has completed payment processing, confirm the intent of necessary.
	useEffect(
		() =>
        onCheckoutSuccess(
				( { processingResponse: { paymentDetails } } ) =>
                    confirmSwishPayment(
						paymentDetails,
						setIsModalOpen,
						setQrCodeData,
						setSwishToken,
						setSwishLink,
						emitResponse
					)
			),
		// not sure if we need to disable this, but kept it as-is to ensure nothing breaks. Please consider passing all the deps.
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);
};
